// Loadash
window._ = require('lodash');

// Jquery
window.$ = window.jQuery = require('jquery');

// Bootstrap
require('bootstrap');

// Select2
require('../../node_modules/select2/dist/js/select2.full');

// Axios
window.axios = require('axios');
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

// Base64
window.Base64 = require('js-base64');

// MomentJS
window.moment = require('moment');

// Daterangepicker
window.daterangepicker = require('../../node_modules/daterangepicker/daterangepicker');
require('./daterangepicker_locales');